<template>
  <div :class="{ 'transparent-box': !availableCar }">
    <div class="c-availability-car d-flex flex-column flex-sm-row">
      <!-- 車両情報 -->
      <c-profile
        class="flex-grow-1 flex-sm-grow-0 w-full max-w-xs"
        :car="car"
      />

      <!-- 空き情報 -->
      <c-calendar-bar
        class="flex-grow-1 mt-4 ml-sm-4"
        :dates="dates"
        :calendar="calendar"
        :states="car.states"
        :anytime="anytime"
        @selected="book"
        v-if="availableCar"
      />

      <c-card-errors class="c-error" v-else :errors="errors" />

    </div>
  </div>
</template>

<style lang="scss">
.v-application.theme--dark .c-availability-car + .c-availability-car {
  border-top: 1px solid rgba(white, .12)
}

.v-application.theme--light .c-availability-car + .c-availability-car {
  border-top: 1px solid rgba(black, .12)
}

.transparent-box {
  pointer-events: none;
}

.c-error {
  display: flex;
  align-items: center;
  background: #ffffff;
  font-size: 1rem;
  width: 100%;
  margin-top:2px;
  margin-bottom: 2px;
}
</style>

<script>
import CProfile from './CProfile'
import CCalendarBar from './CCalendarBar'
import * as time from '@/libs/time'
import CCardErrors from '@/components/CCardErrors'

import { run } from '@/libs/a'

export default {
  name: 'CCar',
  components: {
    CProfile,
    CCalendarBar,
    CCardErrors
  },
  props: {
    stationID: {
      type: Number,
      required: true
    },
    car: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // エラーメッセージ
    errors: [],

    today: time.today()
  }),
  computed: {
    anytime () {
      let result = 0
      if (this.car.attributes.vkey === 1 || this.car.attributes.keykey) {
        result = 1
      }
      return result
    },
    /**
     * ログインしているか
     */
    authed () {
      return this.getters['user/authed']
    },
    /**
     * 初回利用フラグ
     */
    firstTime () {
      const orgcode = this.getters['org/code']
      if (orgcode === 'sagami-rent') {
        return false
      }
      return this.getters['user/limited'](this.today).firstTime
    },
    /**
     * 24時間利用可能フラグ
     */
    user24Flg () {
      return this.getters['user/keykey']
    },

    /**
     * AT限定フラグ
     */
    licenseAT () {
      return this.getters['user/licenseAT']
    },
    /**
     * 車両利用可能フラグ
     */
    availableCar () {
      return this.isAvailableCar24() && this.isAvailableMT()
    }
  },
  methods: {
    book (date) {
      run(async () => {
        await this.dispatch('book/init', {
          stationID: this.stationID,
          allow: undefined,
          schedule: {
            begin: date.date
          },
          car: this.car
        })

        // book に移動
        this.goTo({ name: 'book' })
      })
    },
    isAvailableCar24 () {
      let isAbailable = true
      const attrs = this.car.attributes
      if (attrs.vkey || attrs.keykey) { // 24時間対応車両
        if (!this.authed) { // 未ログイン状態
          this.errors = ['24時間車両は、ログインしてからご利用ください']
          isAbailable = false
        } else if (this.firstTime) { // 初回利用時
          this.errors = ['24時間車両は、初回利用のお客様はご利用いただけません']
          isAbailable = false
        } else if (!this.user24Flg) { // 24時間車両利用不可
          this.errors = ['お客様は24時間車両がご利用できないステータスになっております']
          isAbailable = false
        }
      }
      return isAbailable
    },
    isAvailableMT () {
      let isAbailable = true
      const attrs = this.car.attributes
      if (this.licenseAT && attrs.mission) {
        this.errors.push(['お客様はAT限定免許の為、MT車の予約はできません'])
        isAbailable = false
      }
      return isAbailable
    }
  }
}
</script>
